import React, { useState, useEffect, useRef } from 'react';

const ProfessorsSection = () => {


    const professors = [
        {
            id: 0,
            name: "Lic. Verónica Dandrea",
            specialty: "Directora",
            specialization: "Asesora de imagen y maquilladora",
            experience: "20 años de experiencia",
            image: require('../assets/imagenes/profesoras/profesoras5.png'),
            credentials: "Directora y fundadora de la escuela",
            color: "primary",
            isDirector: true
        },
        {
            id: 1,
            name: "Paola Aguilar",
            specialty: "Dermocosmiatra y maquilladora",
            specialization: "Dermocosmiatría y Medicina Estética",
            experience: "15 años de experiencia",
            image: require('../assets/imagenes/profesoras/profesoras1.png'),
            credentials: "Especialista en tratamientos estéticos avanzados y medicina regenerativa",
            color: "primary"
        },
        {
            id: 2,
            name: "Lorena Blanco",
            specialty: "Master PMU internacional",
            specialization: "Micropigmentación y PMU Avanzado",
            experience: "12 años de experiencia",
            image: require('../assets/imagenes/profesoras/profesoras2.png'),
            credentials: "Certificaciones internacionales en micropigmentación y técnicas PMU",
            color: "secondary"
        },
        {
            id: 3,
            name: "Carolina Elola",
            specialty: "Esteticista",
            specialization: "Tratamientos Faciales y Cosmiatría",
            experience: "10 años de experiencia",
            image: require('../assets/imagenes/profesoras/profesoras3.png'),
            credentials: "Especialista en Dermapen, BB Glow y tratamientos faciales avanzados",
            color: "primary"
        },
        {
            id: 4,
            name: "Dra. Claudia Samada",
            specialty: "Esteticista",
            specialization: "Exosomas y Tratamientos Avanzados",
            experience: "8 años de experiencia",
            image: require('../assets/imagenes/profesoras/profesoras4.png'),
            credentials: "Especialista en medicina regenerativa y bioestimulación celular",
            color: "secondary"
        }
    ];

    const director = professors.find(prof => prof.isDirector);
    const instructors = professors.filter(prof => !prof.isDirector);

    return (
        <section className="py-20 bg-black relative overflow-hidden">
            {/* Simple Background Pattern */}
            <div className="absolute inset-0">
                <div className="absolute inset-0 bg-black"></div>
                <div className="absolute bottom-0 left-0 w-full h-2/3 bg-gradient-to-tr from-amber-900/20 to-transparent rounded-full blur-3xl"></div>
                <div className="absolute top-1/4 right-0 w-3/5 h-2/5 bg-gradient-to-bl from-amber-800/25 to-transparent rounded-full blur-2xl"></div>
            </div>

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                {/* Header */}
                <div className={`text-center mb-16 transition-all duration-1000`}>
                    <span className="inline-block bg-primary text-white px-6 py-2 rounded-full text-sm font-medium mb-6">
                        Nuestro Equipo Docente
                    </span>
                    <h2 className="text-4xl lg:text-5xl font-light text-white mb-4">
                        Instructoras <span className="text-primary">Expertas</span>
                    </h2>
                    <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                        Aprende de profesionales líderes en la industria de la belleza
                    </p>
                </div>

                {/* Director Card */}
                <div className="flex justify-center mb-12">
                    <div className="w-full max-w-sm">
                        <div className="bg-zinc-900/80 backdrop-blur-sm rounded-2xl overflow-hidden border border-primary/50 hover:border-primary transition-all duration-500 hover:scale-105">
                            {/* Director Image/Avatar */}
                            <div className="relative h-64 overflow-hidden">
                                {director.image ? (
                                    <img
                                        src={director.image}
                                        alt={director.name}
                                        className="w-full h-full object-contain"
                                    />
                                ) : (
                                    <div className="w-full h-full bg-zinc-800 flex items-center justify-center">
                                        <div className="w-20 h-20 bg-primary rounded-2xl flex items-center justify-center">
                                            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                        </div>
                                    </div>
                                )}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none"></div>
                            </div>

                            {/* Director Content */}
                            <div className="p-6 text-center">
                                <h3 className="text-xl font-semibold text-white mb-2">
                                    {director.name}
                                </h3>
                                <p className="text-primary text-md font-medium">
                                    {director.specialty}
                                </p>
                                <p className="text-primary text-sm font-medium">
                                    {director.specialization}
                                </p>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Instructors Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    {instructors.map((professor, index) => (
                        <div
                            key={professor.id}
                            className={`bg-zinc-900/80 backdrop-blur-sm rounded-2xl overflow-hidden border border-zinc-700/50 hover:border-primary transition-all duration-500 hover:scale-105`}
                        >
                            {/* Professor Image/Avatar */}
                            <div className="relative h-64 overflow-hidden">
                                {professor.image ? (
                                    <img
                                        src={professor.image}
                                        alt={professor.name}
                                        className="w-full h-full object-contain"
                                    />
                                ) : (
                                    <div className="w-full h-full bg-zinc-800 flex items-center justify-center">
                                        <div className={`w-20 h-20 rounded-2xl flex items-center justify-center ${professor.color === 'primary' ? 'bg-primary' : 'bg-secondary'
                                            }`}>
                                            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                        </div>
                                    </div>
                                )}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none"></div>
                            </div>

                            {/* Content - Name and Specialty */}
                            <div className="p-6 text-center">
                                <h3 className="text-xl font-semibold text-white mb-2">
                                    {professor.name}
                                </h3>
                                <p className="text-primary text-sm font-medium">
                                    {professor.specialty}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProfessorsSection; 